/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ContractAttachmentsAliases {
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_ATTACHMENTS = 'deck-attachments',
  FETCH_ATTACHMENTS = 'fetch-attachments',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  IMAGE_0 = 'image-0',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  TEXT_0 = 'text-0',
}
export { ContractAttachmentsAliases };
